/**
 * Day 79 P5.4 — extracted from TierConfigModal.tsx so validateDrafts can be
 * imported from src/test/day79TierMode.test.ts without tripping the
 * react-refresh/only-export-components ESLint rule (Day 66 baseline =
 * 0 errors / 3 warnings, preserved).
 *
 * Pure function over DraftRow[] returning per-row error string or null.
 * Contiguity check: each row's qty_min must equal previous row's qty_max + 1
 * (no overlap, no gap — matches modal body copy "Tiers must be contiguous").
 */

export interface DraftRow {
  qty_min: string;
  qty_max: string; // empty string = unbounded (only valid on last row)
  unit_cost: string;
}

export function validateDrafts(rows: DraftRow[]): Array<string | null> {
  const errors: Array<string | null> = rows.map(() => null);
  let prevMax: number | null = null;
  rows.forEach((r, i) => {
    const min = Number(r.qty_min);
    const maxRaw = r.qty_max.trim();
    const max = maxRaw === '' ? null : Number(maxRaw);
    const cost = Number(r.unit_cost);
    const isLast = i === rows.length - 1;

    if (!Number.isFinite(min) || min < 1) {
      errors[i] = 'qty_min must be a positive number';
      prevMax = max;
      return;
    }
    if (prevMax !== null && min !== prevMax + 1) {
      errors[i] = `qty_min must be ${prevMax + 1} (tiers must be contiguous)`;
      prevMax = max;
      return;
    }
    if (max !== null) {
      if (!Number.isFinite(max) || max < min) {
        errors[i] = 'qty_max must be ≥ qty_min';
        prevMax = max;
        return;
      }
    } else if (!isLast) {
      errors[i] = 'qty_max may only be empty on the last tier';
      prevMax = max;
      return;
    }
    if (!Number.isFinite(cost) || cost <= 0) {
      errors[i] = 'unit_cost must be greater than 0';
      prevMax = max;
      return;
    }
    prevMax = max;
  });
  return errors;
}
